// extracted by css-extract-rspack-plugin
export default {"cls1":"Tooltip-cls1_DKr","cls2":"Tooltip-cls2_D04 Tooltip-cls1_DKr"};